import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import CollageHero from "../collage/CollageHero";
import Carousel from "../carousel/Carousel";
// import HiringPopup from "../hiringPopup/HiringPopup";
// import BirthdayPopup from "../birthdayPopup/BirthdayPopup";
import TemporaryClosedPopup from "../temporaryClosedPopup/TemporaryClosedPopup";
import "./Home.css";
import gallery1 from "../../assets/images/gallery1.png";
import gallery2 from "../../assets/images/gallery2.png";
import gallery3 from "../../assets/images/gallery3.png";
import gallery4 from "../../assets/images/gallery4.png";
import gallery5 from "../../assets/images/gallery5.png";
import custom_map from "../../assets/images/custom_map.png";
import sushiGallery from "../../assets/images/sushiGallery.png";

const fadeUp = {
  hidden: {
    opacity: 0,
    y: 50,
  },

  show: {
    opacity: 1,
    y: 0,

    transition: {
      duration: 0.9,
      ease: [0.22, 1, 0.36, 1],
    },
  },
};

const cardAnimation = (delay = 0) => ({
  hidden: {
    opacity: 0,
    y: 40,
  },

  show: {
    opacity: 1,
    y: 0,

    transition: {
      duration: 0.8,
      delay,
      ease: [0.22, 1, 0.36, 1],
    },
  },
});

const Home = () => {
  return (
    <>
      <Helmet>
        <title>Hiro Japanese Buffet | All-You-Can-Eat Sushi & Arcade</title>

        <meta
          name="description"
          content="All-you-can-eat sushi, hibachi, seafood, desserts, and arcade fun in Aurora, Colorado."
        />

        <link rel="canonical" href="https://hirojapanesebuffet.com/" />

        <meta property="og:title" content="Hiro Japanese Buffet" />

        <meta
          property="og:description"
          content="Fresh sushi, hibachi, seafood, desserts, and arcade fun in Aurora, Colorado."
        />

        <meta property="og:url" content="https://hirojapanesebuffet.com/" />

        <meta
          property="og:image"
          content="https://hirojapanesebuffet.com/images/hero.jpg"
        />
      </Helmet>

      {/* <HiringPopup /> */}
      {/* <BirthdayPopup /> */}
      <TemporaryClosedPopup />

      <CollageHero />

      <Carousel />

      <main className="home-page">
        {/* INTRO */}
        <motion.section
          className="modern-section"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
        >
          <div className="modern-content">
            <p className="section-label">Welcome To Hiro</p>

            <h2 className="dark-text">A Modern Japanese Buffet Experience</h2>

            <p className="section-description dark-description">
              From handcrafted sushi to hot hibachi and sweet desserts, Hiro
              brings people together over great food and fun.
            </p>

            <div className="modern-tags">
              <span>🍣 Fresh Sushi</span>
              <span>🔥 Hibachi</span>
              <span>🦀 Seafood</span>
              <span>🍰 Desserts</span>
            </div>
          </div>

          <div className="modern-image-wrapper">
            <img
              src={sushiGallery}
              alt="Fresh sushi selection at Hiro Japanese Buffet"
              className="modern-image"
            />
          </div>
        </motion.section>

        {/* FEATURES */}
        <section className="feature-section warm-dark-section">
          <div className="section-container">
            <motion.p
              className="section-label gold-text"
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
            >
              Experience
            </motion.p>

            <motion.h2
              className="light-text"
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
            >
              Fresh Food. Modern Atmosphere.
            </motion.h2>

            <div className="feature-grid">
              <motion.div
                className="feature-card"
                variants={cardAnimation(0.1)}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true }}
              >
                <h3>Fresh Sushi</h3>

                <p>
                  Freshly prepared sushi, sashimi, specialty rolls, and Japanese
                  favorites served daily.
                </p>
              </motion.div>

              <motion.div
                className="feature-card"
                variants={cardAnimation(0.2)}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true }}
              >
                <h3>Hibachi & Hot Foods</h3>

                <p>
                  Hibachi grill favorites, seafood, noodles, appetizers, soups,
                  and rotating buffet selections.
                </p>
              </motion.div>

              <motion.div
                className="feature-card"
                variants={cardAnimation(0.3)}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true }}
              >
                <h3>Arcade Experience</h3>

                <p>
                  Enjoy games and entertainment while dining with friends,
                  family, and large groups.
                </p>
                <p>Coming Soon!</p>
              </motion.div>
            </div>
          </div>
        </section>

        {/* GALLERY */}
        <motion.section
          className="gallery-preview-section dark-section"
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.2 }}
        >
          <div className="section-container">
            <p className="section-label gold-text">Gallery</p>

            <h2 className="light-text">Inside Hiro</h2>

            <p className="section-description light-description">
              Explore our sushi bar, buffet selections, desserts, dining
              atmosphere, and arcade experience.
            </p>
          </div>

          <div className="hiro-gallery-grid">
            <div className="gallery-item large">
              <img src={gallery1} alt="Fresh sushi platter" />
            </div>

            <div className="gallery-item">
              <img src={gallery2} alt="Buffet selections" />
            </div>

            <div className="gallery-item ">
              <img src={gallery3} alt="Desserts at Hiro Buffet" />
            </div>

            <div className="gallery-item">
              <img src={gallery4} alt="Seafood buffet items" />
            </div>

            <div className="gallery-item ">
              <img src={gallery5} alt="Inside Hiro Japanese Buffet" />
            </div>
          </div>
        </motion.section>

        {/* PRICING */}
        <section className="pricing-preview-section cream-section">
          <div className="section-container">
            <motion.p
              className="section-label"
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
            >
              Buffet Pricing
            </motion.p>

            <motion.h2
              className="dark-text"
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
            >
              Buffet Options For Everyone
            </motion.h2>

            <div className="pricing-grid">
              <motion.div
                className="pricing-card"
                variants={cardAnimation(0.1)}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true }}
              >
                <h3>Lunch Buffet</h3>

                <p>
                  Fresh sushi, hibachi favorites, appetizers, and classic buffet
                  selections — perfect for a quick and satisfying lunch.
                </p>
              </motion.div>

              <motion.div
                className="pricing-card"
                variants={cardAnimation(0.2)}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true }}
              >
                <h3>Dinner Buffet</h3>

                <p>
                  Enjoy expanded dinner selections including snow crab legs,
                  premium seafood, and a wider variety of fresh sushi and
                  specialty rolls.
                </p>
              </motion.div>

              <motion.div
                className="pricing-card"
                variants={cardAnimation(0.3)}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true }}
              >
                <h3>Weekend Specials</h3>

                <p>
                  Experience Hiro at its fullest with our most complete buffet
                  selection, including premium seafood, specialty sushi rolls,
                  hibachi, desserts, and weekend-exclusive favorites.
                </p>
              </motion.div>
            </div>

            <motion.div
              className="center-button"
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
            >
              <Link to="/buffet-pricing" className="primary-button">
                View Full Pricing
              </Link>
            </motion.div>
          </div>
        </section>

        {/* LOCATION */}
        <motion.section
          className="location-section white-section"
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
        >
          <div className="section-container location-layout">
            {/* LEFT SIDE */}
            <div className="location-content">
              <p className="section-label">Visit Hiro</p>

              <h2 className="dark-text">Located In Aurora, Colorado</h2>

              <p className="section-description dark-description">
                Conveniently located near H Mart and Ebisu on South Havana
                Street.
              </p>

              <div className="location-tags">
                <span>📍 Near H Mart</span>
                <span>🍣 Japanese Buffet</span>
                <span>🎮 Arcade Coming Soon</span>
              </div>

              <div className="center-button left-align">
                <a
                  href="https://www.google.com/maps/search/?api=1&query=Hiro+Japanese+Buffet+Aurora+CO"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="primary-button"
                >
                  Get Directions
                </a>
              </div>
            </div>

            {/* RIGHT SIDE */}
            <div className="location-map-wrapper">
              <img
                src={custom_map}
                alt="Map showing Hiro Buffet location in Aurora"
                className="location-map"
              />
            </div>
          </div>
        </motion.section>
      </main>
    </>
  );
};

export default Home;
